<template>
  <section>
    <!--工具条-->
    <el-row>
      <el-col :span="24">
        <el-form :inline="true" :model="filters" ref="param">
          <el-form-item label="项目">
            <ProjectList @proSelected="proChange"></ProjectList>
          </el-form-item>
          <el-form-item>
            <el-input v-model="filters.searchTab" placeholder="计划名称" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" v-on:click="doSearch">查询</el-button>
            <el-button v-on:click="showAddView" type="success">创建进度计划</el-button>
          </el-form-item>
          <div class="checkBox" v-if="checkBoxVisible">
            <ul class="checkLabel">
              <li v-for="(item,index) in selectionRow" :key="index">{{item.progressName}}
                <i class="el-icon-delete" @click="delCheckTab(index)"></i>
              </li>
            </ul>
            <div class="checkBtn">
              <el-button v-on:click="checkProgress" type="info" size="small">计划对比</el-button>
            </div>
          </div>
        </el-form>
      </el-col>
    </el-row>
    <!--列表 -->
    <template>
      <el-table :data="data" highlight-current-row v-loading="loading" ref="multipleTable"
                @select="checkSingleTab" @select-all="checkedTab">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column type="index" label="序号" width="100" align="center">
        </el-table-column>
        <el-table-column prop="progressName" label="名称" align="center">
        </el-table-column>
        <el-table-column prop="beginTime" label="开始时间" align="center" :formatter="formatDate">
        </el-table-column>
        <el-table-column prop="endTime" label="结束时间" align="center" :formatter="formatDate">
        </el-table-column>
        <el-table-column prop="modelName" label="模型" align="center" width="155">
        </el-table-column>
        <el-table-column prop="modifyName" label="制定人" align="center" width="155">
        </el-table-column>
        <el-table-column label="操作" width="251" align="center">
          <template slot-scope="scope">
            <el-button size="small" type="warning" @click="showDetailView(scope.$index, scope.row)">计划详情</el-button>
            <el-button size="small" @click="showEditView(scope.$index, scope.row)">编辑</el-button>
            <el-button type="danger" size="small" @click="doDel(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--工具条-->
      <el-col :span="24" class="pageToolbar">
        <el-pagination layout="prev, pager, next" @current-change="searchPage" :page-size="limit" :total="total"
                       class="layout-right">
        </el-pagination>
      </el-col>
    </template>
    <!-- 表单视图 -->
    <el-dialog title="" :visible.sync="formVisible" :close-on-click-modal="false" :modal="false">
      <div slot="title" style="height: 60px;line-height: 60px;"></div>
      <div v-if="formVisible">
        <ProgressForm :option="option" @doSubmit="doSubmit" @doCancel="doCancel" :form-data="formData"></ProgressForm>
      </div>
    </el-dialog>
    <!-- 计划详情视图 -->
    <el-dialog title="" :visible.sync="detailVisible" :close-on-click-modal="false" @close="detailClosed"
               :modal="false" width="98%" :top="dialogTop" :fullscreen="dialogFullScreen" :destroy-on-close="true">
      <div slot="title" style="height: 30px;line-height: 30px; text-align: center">{{this.scheduledName}}</div>
      <div v-if="detailVisible">
        <DetailView :data="model" :scheduledId="scheduledId" :scheduled-name="scheduledName"></DetailView>
      </div>
    </el-dialog>
    <!-- 计划对比 -->
    <el-dialog title="" :visible.sync="checkVisible" :close-on-click-modal="false" @close="detailClosed"
               :modal="false" width="98%" :top="dialogTop" :fullscreen="dialogFullScreen" :destroy-on-close="true">
      <div slot="title" style="height: 30px;line-height: 30px;"></div>
      <div v-if="checkVisible">
        <CheckView :scheduled-list="selectionRow"></CheckView>
      </div>
    </el-dialog>

  </section>
</template>

<script>
  import {searchProgress, delProgress, progressDetail, detailModel} from '../../api/api'
  import ProjectList from "../command/ProjectList";
  import ProgressForm from "./ProgressForm";
  import DetailView from "./DetailView";
  import CheckView from "./CheckView";

  export default {
    name: "Progress",
    components: {CheckView, DetailView, ProgressForm, ProjectList},
    data() {
      return {
        filters: {},
        loading: false,
        total: 2,
        page: 1,
        limit: 15,
        data: [],
        formVisible: false,
        option: 0,
        formData: {},
        selectionRow: [],
        checkBoxVisible: true,
        detailVisible: false,
        model: {modelName: null},
        dialogTop: '2vh',
        dialogFullScreen: false,
        label: null,
        scheduledId: null,
        checkVisible: false,
        scheduledName:''
      }
    },
    methods: {
      detailClosed: function () {
        //window.location.href= '/progress'
        //this.$router.push('/progress');
      },
      //计划详情
      showDetailView: function (index, row) {
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.progress, this.GLOBAL.option.message, this);
        if (res) {
          this.label = row.progressName;
          detailModel({id: row.modelId}, this.GLOBAL.header).then(result => {
            if (result.success) {
              this.model = result.data;
              this.scheduledId = row.id;
              this.scheduledName = row.progressName;
              this.detailVisible = true;
            }
          });
        }
      },
      //计划对比
      checkProgress: function () {
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.progress, this.GLOBAL.option.check, this);
        if (res) {
          if (this.selectionRow.length < 2) {
            this.$message({
              message: '请选择对比计划，最多两项',
              type: 'warning'
            })
          } else {
            this.checkVisible = true;
          }
        }
      },
      //添加单一对比项
      checkSingleTab: function (selection, row) {
        let hasSelected = false;
        for (let i = 0; i < selection.length; i++) {
          if (selection[i].id == row.id) {
            hasSelected = true;
            break;
          }
        }
        if (this.selectionRow.length >= 2 && hasSelected) {
          this.$message({
            message: '仅能添加两项对比',
            type: 'warning'
          })
          this.$refs.multipleTable.toggleRowSelection(row, false);
        } else {
          if (selection.length == 0) {
            this.selectionRow = [];
          }
          if (hasSelected) {
            this.selectionRow.push(row);
          } else {
            for (let i = 0; i < this.selectionRow.length; i++) {
              if (this.selectionRow[i].id == row.id) {
                this.selectionRow.splice(i, 1);
                break;
              }
            }
          }
        }
      },
      //添加对比项
      checkedTab: function (selection) {
        if (selection.length > 2) {
          this.$message({
            message: '仅能添加两项对比',
            type: 'warning'
          })
          this.$refs.multipleTable.clearSelection()
        } else if (selection.length > 0) {
          for (let i = 0; i < selection.length; i++) {
            this.selectionRow.push(selection[i]);
          }
        }else{
          this.selectionRow = [];
        }
      },
      //删除对比项
      delCheckTab: function (index) {
        this.$refs.multipleTable.toggleRowSelection(this.selectionRow[index]);
      },
      //查询
      searchData: function () {
        this.GLOBAL.checkRole(this.GLOBAL.fun.progress, this.GLOBAL.option.select, this);
        this.loading = true
        this.filters.page = this.page
        this.filters.limit = this.limit//请求参数
        if (this.filters.searchTab == '') {
          this.filters.searchTab = null
        }
        this.filters.proId = this.filters.proId == '' ? null : this.filters.proId;
        this.filters.comId = null;
        searchProgress(this.filters, this.GLOBAL.header).then(result => {
          if (result.success) {
            this.data = result.data.result
            this.total = result.data.total
            this.loading = false
          }
        });
      },
      //查询
      doSearch: function () {
        this.searchData();
      },
      searchPage: function (val) {
        this.page = val
        this.searchData()
      },
      //创建计划视图
      showAddView: function () {
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.progress, this.GLOBAL.option.create, this);
        if (res) {
          this.option = 0;
          this.formData = {proId: null, modelId: null, time: null}
          this.formVisible = true;
        }
      },
      //编辑视图
      showEditView: function (index, row) {
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.progress, this.GLOBAL.option.update, this);
        if (res) {
          this.option = 1;
          this.detailId = row.id;
          progressDetail({id: row.id}, this.GLOBAL.header).then(result => {
            if (result.success) {
              this.formData = result.data;
              this.formVisible = true;
            }
          });
        }
      },
      //表单提交后回调
      doSubmit: function () {
        this.searchData();
        this.formVisible = false;
      },
      //表单取消后回调
      doCancel: function () {
        this.formVisible = false;
      },
      //删除
      doDel: function (index, row) {
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.progress, this.GLOBAL.option.delete, this);
        if (res) {
          this.$confirm('确认删除该记录吗?', '提示', {
            type: 'warning'
          }).then(() => {
            delProgress({id: row.id}, this.GLOBAL.header).then(result => {
              if (result.success) {
                this.$message({
                  message: '删除成功',
                  type: 'success'
                })
                this.searchData()
              }
            })
          }).catch(() => {
          })
        }
      },
      //项目更改
      proChange: function (proId) {
        this.filters.proId = proId;
        this.searchData();
      },
      formatDate: function (row, column, cellValue) {
        if (cellValue != null)
          return this.GLOBAL.formatTimeToStr(cellValue, 'yyyy-MM-dd')
      },
    }
  }
</script>

<style scoped>
  .pageToolbar {
    margin-bottom: 10px;
  }

  .checkBox {
    height: 40px;
    float: right;
    border: 1px dashed green;
  }

  .checkBtn {
    float: right;
    margin-right: 10px;
    margin-top: 4px;
    margin-left: 20px;
  }

  .checkLabel {
    margin: 0;
    padding: 0;
    height: 40px;
    float: left;
  }

  .checkLabel li {
    list-style: none;
    height: 30px;
    line-height: 30px;
    float: left;
    margin-top: 4px;
    background: #e8e8e8;
    padding-left: 10px;
    padding-right: 10px;
    margin-left: 20px;
    border: 1px solid #dcdcdc
  }

  .el-icon-delete {
    margin-left: 15px;
    cursor: pointer;
  }

  /*.el-dialog__header {*/
  /*  padding: 0px;*/
  /*}*/

  /*.el-dialog__body {*/
  /*  padding: 0px 20px 10px 20px;*/
  /*}*/

  /*.el-dialog__headerbtn {*/
  /*  top:8px;*/
  /*}*/


</style>



// WEBPACK FOOTER //
// src/components/progress/Progress.vue